/**
 * 发送GA事件
 * @param {Object} orderInfo 订单信息
 * @param {String} eventName 事件名称
 * @param {String} field 字段名
 * @param {Object} form 表单数据
 * @param {Object} options 其他选项（key, requestingTime, cardNumFocusTime, lang）
 * @param {Object} extra 额外信息
 */
export function sendGaEvent(orderInfo, eventName, field = '', form, options, extra = {}) {
  try {
    // 解构options获取相关参数
    const { key, requestingTime, cardNumFocusTime, lang } = options || {};
    // 设置基本参数
    const params = {
      key,
      merchant_id: orderInfo && orderInfo.merchantNo,
      txn_id: orderInfo && orderInfo.txnId,
      checkout_type: '卡支付',
      ...extra,
    };
    // 如果有字段名，则添加到参数中
    if (field) {
      params.element_name = field;
    }
    // 针对特定事件添加额外参数
    if (['visit_checkout', 'exit_checkout', 'click_payment_button'].includes(eventName)) {
      params.checkout_order_amount = orderInfo && orderInfo.txnAmount;
      params.checkout_order_currency = orderInfo && orderInfo.txnCurrency;
      params.checkout_language = lang;
      params.checkout_country = form.country;
    }
    // 处理访问结账页面事件的特殊参数
    if (eventName === 'visit_checkout' && requestingTime) {
      params.api_requesting_time = (requestingTime === -1 ? 0 : (Date.now() - requestingTime));
      params.visit_checkout_count = 1;
    }
    // 处理访问结账时间事件的特殊参数
    if (eventName === 'visit_checkout_time' && requestingTime) {
      params.time_spent = (requestingTime === -1 ? 0 : (Date.now() - requestingTime));
    }
    // 处理点击支付按钮事件的特殊参数
    if (eventName === 'click_payment_button' && cardNumFocusTime) {
      params.time_spent = Date.now() - cardNumFocusTime;
    }
    // 触发GA事件
    window.gtag('event', eventName, params);
  } catch (error) { }
}
